import { Injectable } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { ReferenceTypesService } from '@control-tower/platform-loads';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class ReferenceTypeFacade extends AbstractTypeEntityFacade<ReferenceTypesService> {
    constructor(
        typeService: ReferenceTypesService,
        store: TypeEntityStore,
        logger: LoggerService
    ) {
        super(
            store,
            logger,
            typeService,
            'referenceTypeGetAll',
            TypeEntityTypes.ReferenceType
        );
    }
}
